var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store-card ml-0 mr-0 d-flex align-items-center justify-content-center h5"},[_vm._v(" "+_vm._s(_vm.store.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }